(function () {
  'use strict';

  angular.module('cvsApp')
    .controller('PaymentCardInfoCtrl', ["$scope", "$rootScope", "$state", '$timeout', '$stateParams', 'userSession', 'commonService', 'addDataService', 'webAnalytics', "userSession", "$anchorScroll", "modifyFormOfPaymentService", "retrieveFormOfPaymentService", "accountDataService", "loggerService", "loggerServiceHelper",
          function ($scope, $rootScope, $state, $timeout, $stateParams, UserSession, commonService, guestDataService, webAnalytics, userSession, $anchorScroll, modifyFormOfPaymentService, RFOP, AccountDataSvc, loggerService, loggerServiceHelper ) {

        var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setFlowType(UserSession.paymentType) + loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.AddEditCreditCard));
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START) + loggerServiceHelper.setDescription("add a cardit card page " +
        window.location));

        // $scope.stateParams  = localStorage.getItem('stateParams') ? JSON.parse(localStorage.getItem('stateParams')) : $stateParams;
        // localStorage.removeItem('stateParams');

        /*Scroll to top*/
        cvsUtility.genralPostMessage("SCROLL_TO", {
          "scroll": true
        });
        //cvsUtility.resetSessoinTimeOut();
        var _addModeInd = false;
        $scope.content = wcmContent;
        $scope.retrieveCardExpiryError = $stateParams.expired ? JSON.parse($stateParams.expired) : false;
        $stateParams.mopid = localStorage && localStorage.getItem("mopid") ? localStorage.getItem("mopid") : $stateParams.mopid;
        //$scope.stateparamsmopid = localStorage && localStorage.getItem("mopid") ? localStorage.getItem("mopid") :  $scope.stateParams.mopid;
        $scope.addNew = $stateParams.mopid == undefined;
        $scope.SPECIFIC_ERROR = false;
        $scope.SERVER_ERROR = false;
        $scope.updateError = false;
        // $scope.visaCardValidataion = false; (GST-9 Edit flow credit card consent, temporarily descoped)
        /**
         * viswa 02/04/2020 - ITPR017031 - add credit card info page
         * Added WTS pagename tag
         */
        var utagObj = {};
        if (self == top) {
          utagObj.pagename = 'PAYMENT-guestAddEditCreditCard';
        }
        if (UserSession.registered) {
          if ($scope.addNew) {
            log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.AddCreditCard));
            webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "addCreditCard");

          } else {
            log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.EditCreditCard));
            webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "editCreditCard");
          }
        } else {
          webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestAddEditCreditCard");
        }
        var stateMopId = $stateParams.mopid;
        $scope.accountDetails = $stateParams.mopid ? UserSession.accountData.getMopById(stateMopId) : UserSession.getNewMopAccountObject("CCARD");
        $scope.editFromAutoPayments = $stateParams.editMode;
        if (!$scope.accountDetails) {
          $scope.accountDetails = guestDataService.getNewMOP();
          _addModeInd = true;
        }
        if (!$scope.addNew) {
          if ($scope.accountDetails.relationshipToCardHolder === 'SELF') {
            $scope.relationshipToCardHolder = $scope.accountDetails.relationshipToCardHolder + ' (PATIENT)';
          } else {
            $scope.relationshipToCardHolder = $scope.accountDetails.relationshipToCardHolder;
          }
        }

        var formData = $scope.accountDetails;
        $scope.checkValidCredit = "";

        /**
         * GST-3028, CC consent Edit flow, temporarily descoped - Yogi. 
         */

        /*$scope.validateCardNumber = function(cardNumber){
          var cardNumber=cardNumber+"";
          if(cardNumber && cardNumber.length>=14){
            var type= cvsUtility.getCardType(cardNumber);
            if(!type){
              $scope.cardInfoForm.cardAccountNum.$valid=false;
              $scope.invalidCardIndicator=true;
              return false;
            }
            if(cvsUtility.validCreditCard(cardNumber)==false){
              $scope.cardInfoForm.cardAccountNum.$valid=false;
              $scope.invalidCardIndicator=true;
              return false;
            }
            if(type && cvsUtility.validCreditCard(cardNumber)){
              $scope.cardInfoForm.cardAccountNum.$valid=true;
              $scope.invalidCardIndicator=false;
            }
            return true;
          }
        };*/

        /**SPEC-1847 */
        $scope.hideCardNumber = function (card_info) {

          if ($scope.cardInfoForm.cardAccountNum.$viewValue !== '' && $scope.invalidCardIndicator == false) {
            var orig = $scope.cardInfoForm.cardAccountNum.$viewValue;
            $scope.mask_accountNumber = orig.slice(4).replace(/\d/g, 'X') + orig.slice(-4);
            $scope.showMask = true;
            $scope.paymentMopType = getCardType($scope.cardInfoForm.cardAccountNum.$viewValue);
            //document.getElementById('show-cc').focus(); 
            //var element = angular.element("#show-cc");
            //element.focus();
          }

          if ($scope.cardInfoForm.cardAccountNum.$viewValue === '') {
            $scope.mask_accountNumber = "";
            $scope.showMask = false;
            $scope.paymentMopType = "";
          }
        };

        /**SPEC-1847 */
        $scope.showCardNumber = function () {
          $scope.showMask = false;
          setTimeout(function () {
            $("#ccShowBlock input").focus();
          }, 100);

        };

        /**SPEC-2129 */
        $scope.$on('$locationChangeStart', function (event, toState) {
          Object.keys(UserSession.persit).forEach(function (key) {
            delete UserSession.persit[key];
          });
          //localStorage.clear();
        });

        $scope.$on('$stateChangeStart', function (event, toState, fromState) {

          if (toState.url != "/make-payment/payment-card-info") {
            Object.keys(UserSession.persit).forEach(function (key) {
              delete UserSession.persit[key];
            });
            //localStorage.clear();
          };
        });


        function getCardType(number){

            // visa
            var re = new RegExp("^4");
            if (number.match(re) !== null)
                return "VISA";

            // Mastercard
            re = new RegExp("^(5[1-5]|2[2-7])");
            if (number.match(re) !== null && number.length==16)
                return "MASTERCARD";

            // AMEX
            re = new RegExp("^3[47]");
            if (number.match(re) !== null)
                return "AMERICAN EXPRESS";

            // Discover
            re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
            if (number.match(re) !== null)
                return "DISCOVER";

            // Diners - club
            re = new RegExp("3(?:0[0-5]|[68][0-9])[0-9]{11}");
            if (number.match(re) !== null)
                return "DINERS CLUB";
            
            return "";
        };

        $scope.validateCardNumber = function (card_info) {
          if (card_info.card_type === null || !card_info.valid) {
            $scope.cardInfoForm.cardAccountNum.$setValidity("cardAccountNum", false);
            $scope.invalidCardIndicator = true;
            return false;
          }
          $scope.cardInfoForm.cardAccountNum.$setValidity("cardAccountNum", true);
          $scope.invalidCardIndicator = false;
          return true;
        };

        $scope.ccErrorTypeValidation = function () {
          if ($scope.cardInfoForm.cardAccountNum.$error.minlength) {
            return "Card number is invalid. Card number must be 14, 15 or 16 digits."
          } else {
            return '';
          }
        }

        function onGetPaymentSuccess(response) {
          angular.element("#mydiv").hide();
          angular.element("#specialtySpinner").hide();
          angular.element("#loader").hide();
          if (loggerServiceHelper) {
            log.info(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
              loggerServiceHelper.setStep(CVSLOGHELPER.STEP.ServiceCallDone) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService"));
          }
          if (response.getError() === '') {

            //log for success retrieveFormOfPayment
            if (loggerServiceHelper) {
              log.info(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("SUCCESS") +
                loggerServiceHelper.setDescription(" SUCCESS " + JSON.stringify(response)));
            }

            // update the list of payment methods
            AccountDataSvc.updateListMop(response.getPaymentInfos());

            $rootScope.isCardAddSuccess = true;
            var lastFour = $scope.accountDetails.accountNumber.substring($scope.accountDetails.accountNumber.length - 4);
            $rootScope.addedCardDetails = {accountNumber: lastFour, mopType: $scope.accountDetails.payment.mopType};

            $state.go("payment-methods");

          } else {
            var showError = response.getError();
            var statusCode = showError.statusCode;
            switch (statusCode) {
              case 'DBPL9999': {
                if (log.error && loggerServiceHelper) {
                  log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                }
                var pageError = cvsUtility.getPageError(response, 'Fatal', 'retrieveFormOfPaymentService');
                $scope.referenceId = response.apiResponse.showError.refId;
                $scope.updateError = true;
                $rootScope.$emit("updateAccountError", $scope.updateError);

                setTimeout(function () {
                  document.getElementById('paymentInlineAlert').focus();
                  document.getElementById('paymentInlineAlert').scrollIntoView({
                    behavior: 'smooth'
                  });
                }, 100);

                break;
              }
              case '6006': {
                if (log.error && loggerServiceHelper) {
                  log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                }
                // update the list of payment methods
                AccountDataSvc.updateListMop([]);
                AccountDataSvc.setRecentPaymentMethodId("");
                break;
              }
              default: {
                if (log.error && loggerServiceHelper) {
                  log.error(loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.RetrievePayments) + loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) +
                    loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setServiceName("retrieveFormOfPaymentService") + loggerServiceHelper.setStatus("ERROR") + loggerServiceHelper.setDescription(" ERROR " + JSON.stringify(response)));
                }
                modal.retrievepaymentsmessage.retrievePaymentFailed = true; // Flag to show retrieve payments failed banner
                $rootScope.$emit("retrievePaymentsFailed", modal.retrievepaymentsmessage);

                setTimeout(function () {
                  document.getElementById('retrievePaymentsErrorBlock').focus();
                  document.getElementById('retrievePaymentsErrorBlock').scrollIntoView({
                    behavior: 'smooth'
                  });
                }, 100);
                break;
              }
            }
          }
        }

        /**
         * IM5900218 - Oct 2017 release - IM fix to focus on correct first error field
         * @param cardInfoForm
         */
        $scope.scrollToErrors = function (cardInfoForm) {
          if (cardInfoForm.$error) {
            var error = cardInfoForm.$error;
            var ctrl = angular.element("[name='" + cardInfoForm.$name + "']").find('.ng-invalid');
            if (error) {
              if (ctrl.is('select') && $scope.isMobile) {
                return;
              } else {
                angular.element("[name='" + cardInfoForm.$name + "']").find('.ng-invalid:visible:first').focus();
              }
            }
          }
        }
        
        // onclick of save button 
        $scope.continue = function (cardInfoForm) {

          $scope.visaCardValidataion = false;
          $scope.updateError = false;

          if (cardInfoForm.$valid) {
            if (!cardInfoForm.cardAccountNum.value && cardInfoForm.cardAccountNum.$modelValue != undefined) {
              if ($scope.addNew || $scope.accountDetails.transactionMode === 'ADD') {
                /**
                 * Yogi 04/12/2020  GST-170 UI - Create Tags for Add a card
                 * Added WTS link_name, link_trackvars, link_trackevents
                 */
                var utagObj = {};
                utagObj.link_name = "Custom: add credit card: save button";
                utagObj.link_trackvars = "events";
                utagObj.link_trackevents = "event00";
                webAnalytics.webTrendsUtag("LINK", utagObj, undefined);
                if (!$scope.cardInfoForm.cardAccountNum.$valid) {
                  return false;
                }
                $scope.accountDetails.accountNumber = cardInfoForm.cardAccountNum.$modelValue;
                $scope.accountDetails.cardholder.firstName = cardInfoForm.cardHolderFirst.$modelValue;
                $scope.accountDetails.cardholder.lastName = cardInfoForm.cardHolderLast.$modelValue;
                $scope.accountDetails.expiryDate.month = cardInfoForm.expMonth.$modelValue;
                $scope.accountDetails.expiryDate.year = cardInfoForm.expYear.$modelValue;
                $scope.accountDetails.payment.mopType = getCardType($scope.accountDetails.accountNumber);
                
                var addressSelectionMethod = cardInfoForm.primary && cardInfoForm.primary.$modelValue;
                if (addressSelectionMethod && addressSelectionMethod == "primary") {
                  $scope.accountDetails.billingAddress = $scope.session.accountData.primaryAddress;
                }
                if (UserSession.registered) {
                  $scope.accountDetails.transactionMode = "ADD";
                  if (localStorage) {
                    localStorage.setItem("transactionMode", "ADD");
                  }
                }
                if ($scope.accountDetails.billingAddress && cardInfoForm.billingSt1 && cardInfoForm.billingSt1.$modelValue) {
                  $scope.accountDetails.billingAddress = {
                    addressLine1: cardInfoForm.billingSt1.$modelValue,
                    "addressLine2": cardInfoForm.billingSt2.$modelValue,
                    city: cardInfoForm.billingCity.$modelValue,
                    "state": cardInfoForm.billingState.$modelValue,
                    "zipCode": cardInfoForm.billingZip.$modelValue,
                    "zipCodeExt": ""
                  }

                }

                if (cardInfoForm && cardInfoForm.accountRelationship && cardInfoForm.accountRelationship.$modelValue) {
                  $scope.accountDetails.relationshipToCardHolder = cardInfoForm.accountRelationship.$modelValue;
                }

                if ($scope.accountDetails.transactionMode == "ADD") {
                  var accountNumber = commonService.getEncryptedRSAData($scope.accountDetails.accountNumber);
                  if (!accountNumber || accountNumber == $scope.accountDetails.accountNumber) {
                    $scope.ENCRYPTION_ERROR = true;
                    return;
                  } else {
                    $scope.accountDetails.encryptedAccountNumber = accountNumber;
                  }
                }
                if(formData.transactionMode == 'ADD'){
                  $scope.accountDetails.createdBy = "DIGITAL WEB";
                } 
                
                UserSession.addNewMop($scope.accountDetails);
                guestDataService.setNewMop($scope.accountDetails);
                Object.keys(userSession.persit).forEach(function (key) {
                  userSession.persistCopy[key] = userSession.persit[key];
                });
                //$state.go("review-payments");

                 // calling MFOP service only on my account page 
                if ($rootScope.customelementsPayments == true) {
                  modifyFormOfPaymentService.modifyFormOfPayment(formData, function (response) {
                    angular.element("#mydiv").show();
                    angular.element("#specialtySpinner").show();
                    angular.element("#loader").show();
                    if (!response.apiResponse.showError) {
                     
                    // call retriveformofpayment service
                    RFOP.retrieveFormOfPaymentdata(onGetPaymentSuccess);

                    } else {
                      var header = response.getHeader();
                      var statusCode = header.statusCode;
                      switch (statusCode) {
                        case 'SET_MOP_021':
                        case 'DBPL6028': {
                          var pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPayment');
                          var utagObj = {
                            page_error: pageError
                          };
                          webAnalytics.webTrendsUtag("LINK", utagObj, undefined, undefined);
                          $scope.visaCardValidataion = true;
                          setTimeout(function () {
                            document.getElementById('paymentcardErrorBlock').focus();
                            document.getElementById("paymentcardErrorBlock").scrollIntoView({
                              behavior: 'smooth'
                            });
                          }, 100);
                          break;
                        }
                        default: {
                          var pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPayment');
                          var utagObj = {
                            page_error: pageError
                          };
                          webAnalytics.webTrendsUtag("LINK", utagObj, undefined, undefined);
                          $scope.referenceId = response.apiResponse.showError.refId;
                          $scope.updateError = true;
                          setTimeout(function () {
                              document.getElementById('paymentInlineAlert').focus();
                              document.getElementById('paymentInlineAlert').scrollIntoView({
                                behavior: 'smooth'
                              });
                            },
                            100);
                        }
                      }

                      angular.element("#mydiv").hide();
                      angular.element("#specialtySpinner").hide();
                      angular.element("#loader").hide();
                    }

                  });
                }

              } 
              // Editing the card
              else {
                if ($scope.accountDetails) {
                  $scope.accountDetails.accountNumber = cardInfoForm.cardAccountNum.$modelValue;
                  $scope.accountDetails.cardholder.firstName = cardInfoForm.cardHolderFirst.$modelValue;
                  $scope.accountDetails.cardholder.lastName = cardInfoForm.cardHolderLast.$modelValue;
                  if (!$scope.accountDetails.expiryDate) {
                    $scope.accountDetails.expiryDate = {};
                  }
                  $scope.accountDetails.expiryDate.month = cardInfoForm.expMonth.$modelValue;
                  $scope.accountDetails.expiryDate.year = cardInfoForm.expYear.$modelValue;

                  var addressSelectionMethod = cardInfoForm.primary && cardInfoForm.primary.$modelValue;
                  if (addressSelectionMethod && addressSelectionMethod == "primary") {
                    $scope.accountDetails.billingAddress = $scope.session.accountData.primaryAddress;
                  }
                  if ($scope.accountDetails.billingAddress) {
                    $scope.accountDetails.billingAddress = {
                      addressLine1: cardInfoForm.billingSt1.$modelValue,
                      "addressLine2": cardInfoForm.billingSt2.$modelValue,
                      city: cardInfoForm.billingCity.$modelValue,
                      "state": cardInfoForm.billingState.$modelValue,
                      "zipCode": cardInfoForm.billingZip.$modelValue,
                      "zipCodeExt": ""
                    }
                  }
                  if (cardInfoForm && cardInfoForm.accountRelationship && cardInfoForm.accountRelationship.$modelValue) {
                    $scope.accountDetails.relationshipToCardHolder = cardInfoForm.accountRelationship.$modelValue;
                  }
                  UserSession.updateMop($scope.accountDetails);
                  if (localStorage) {
                    localStorage.setItem("transactionMode", "EDIT");
                    localStorage.setItem("mopid", $stateParams.mopid);
                  }
                  $scope.accountDetails.transactionMode = "EDIT";
                  formData.createdBy = "DIGITAL WEB";
                  if (formData.payment.method == "CHECK") {
                    formData.achAcceptanceInd = "true"
                  } else {
                    formData.achAcceptanceInd = "";
                  }
                }
                // call MFOP service
                modifyFormOfPaymentService.modifyFormOfPayment(formData, function (response) {
                  if (!response.apiResponse.showError) {
                    //SPEC-2018: Item 5 & 6 - 06/2019
                    if ($rootScope.expiryFlag) {
                      var utagObj = {
                        link_name: "Custom: Edit Expiring Card: Save"
                      }
                    } else {
                      var utagObj = {
                        link_name: "Custom: edit credit Card: Save button",
                        link_trackvars : "events",
                        link_trackevents : "event00"
                      }
                    }
                    webAnalytics.webTrendsUtag("LINK", utagObj, undefined, undefined);
                    $rootScope.isCardUpdateSuccess = true;
                    if ($rootScope.expiryFlag) {
                      //SPEC-2018: item 3 - 06/2019
                      webAnalytics.webTrendsUtag("LINK", {
                        'link_name': 'Custom:save expiring card link'
                      });
                    }
                    $state.go("payment-methods");

                  }
                 
                  else if (response.apiResponse.showError) {
                    // var statusCode=response.apiResponse.showError.statusCode;
                    // setErrorMessage(statusCode);
                    var pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPayment');
                    var utagObj = {
                      page_error: pageError
                    };
                    webAnalytics.webTrendsUtag("LINK", utagObj, undefined, undefined);
                    $scope.referenceId = response.apiResponse.showError.refId;
                    $scope.updateError = true;
                    setTimeout(function () {
                        document.getElementById('paymentInlineAlert').focus();
                        document.getElementById('paymentInlineAlert').scrollIntoView({
                          behavior: 'smooth'
                        });
                      },
                      100);


                  } else {
                    var pageError = cvsUtility.getPageError(response, 'Fatal', 'modifyFormOfPayment');
                    var utagObj = {
                      page_error: pageError
                    };
                    webAnalytics.webTrendsUtag("LINK", utagObj, undefined, undefined);
                    $scope.referenceId = response.apiResponse.showError.refId;
                    $scope.updateError = true;
                    setTimeout(function () {
                        document.getElementById('paymentInlineAlert').focus();
                        document.getElementById('paymentInlineAlert').scrollIntoView({
                          behavior: 'smooth'
                        });
                      },
                      100);

                  }
                });
                
              }
            } 
            else {
              if ($scope.addNew || _addModeInd) {
                if (!$scope.validateCardNumber(cardInfoForm.cardAccountNum.value)) {
                  return false;
                }
                $scope.accountDetails.accountNumber = cardInfoForm.cardAccountNum.value;
                $scope.accountDetails.cardholder.firstName = cardInfoForm.cardHolderFirst.value;
                $scope.accountDetails.cardholder.lastName = cardInfoForm.cardHolderLast.value;
                $scope.accountDetails.expiryDate.month = cardInfoForm.expMonth.value;
                $scope.accountDetails.expiryDate.year = cardInfoForm.expYear.value;
                if($scope.accountDetails.payment){
                  $scope.accountDetails.payment.mopType = getCardType($scope.accountDetails.accountNumber)
                };

                var addressSelectionMethod = cardInfoForm.primary && cardInfoForm.primary.value;
                if (addressSelectionMethod && addressSelectionMethod == "primary") {
                  $scope.accountDetails.billingAddress = $scope.session.accountData.primaryAddress;
                }
                /*if(UserSession.registered){
                  $scope.accountDetails.transactionMode="ADD";
                }*/
                if (!$scope.primaryAddress && $scope.accountDetails.billingAddress && !$scope.accountDetails.billingAddress.addressLine1) {
                  $scope.accountDetails.billingAddress = {
                    addressLine1: cardInfoForm.billingSt1.value,
                    "addressLine2": cardInfoForm.billingSt2.value,
                    city: cardInfoForm.billingCity.value,
                    "state": cardInfoForm.billingState.value,
                    "zipCode": cardInfoForm.billingZip.value,
                    "zipCodeExt": ""
                  }

                }

                if (cardInfoForm && cardInfoForm.accountRelationship && cardInfoForm.accountRelationship.value) {
                  $scope.accountDetails.relationshipToCardHolder = cardInfoForm.accountRelationship.value;
                }

                UserSession.addNewMop($scope.accountDetails);
                guestDataService.setNewMop($scope.accountDetails);
              } else {
                $scope.accountDetails.transactionMode = "EDIT";
              }

            }
            if (!$scope.accountDetails.transactionMode == "EDIT") {
              //Spec - 819 redirect to payments-methods.
              if (UserSession.paymentType === 'auto') {
                log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.FORM_SUBMIT) + loggerServiceHelper.setStep("save&Continue") + loggerServiceHelper.setDescription("navigate to payment-methods"));
                $state.go("automatic-payments");
              } else {
                log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.FORM_SUBMIT) + loggerServiceHelper.setStep("save&Continue") + loggerServiceHelper.setDescription("navigate to review-payments "));
                $state.go("review-payments");
              }
            } 
            else if ($scope.accountDetails.transactionMode == "ADD") {
              console.log("credit card save btn", $rootScope.customelementsPayments);
              if ($rootScope.customelementsPayments == false || $rootScope.customelementsPayments === undefined) {
                if (UserSession.paymentType === 'auto') {
                  log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.FORM_SUBMIT) + loggerServiceHelper.setStep("save&Continue") + loggerServiceHelper.setDescription("navigate to payment-methods"));
                  $state.go("automatic-payments");
                } else {
                  log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.FORM_SUBMIT) + loggerServiceHelper.setStep("save&Continue") + loggerServiceHelper.setDescription("navigate to review-payments "));
                  $state.go("review-payments");
                }
              } else {
               // $state.go('payment-methods');
              }
            }
            log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.FORM_SUBMIT) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));

          }

        };

        $rootScope.$on('setCardAccountNumOnAdd', function (event, data) {
          if ($scope.hasOwnProperty('cardInfoForm') && $scope.cardInfoForm && $scope.cardInfoForm.hasOwnProperty('cardAccountNum')) {
            $scope.cardInfoForm.cardAccountNum.$viewValue = data.cardAccountNum;
          }
        })
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setDescription("Add Edit Card Info page load completed"));
      }
    ]);
})();

var saveClick=()=>{
  setTimeout(()=>{
    var d=document.getElementsByClassName('validationMessage');
    if(d[0].innerHTML=="You must enter a card number."){
      d[0].setAttribute("for","card-accountNumber");
    }
  },1000);
}